export var StoreConstants;
(function (StoreConstants) {
    StoreConstants[StoreConstants["MaxBuyAmount"] = 100] = "MaxBuyAmount";
})(StoreConstants || (StoreConstants = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/StoreConstants.ts
// module id = 2763
// module chunks = 3